var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTeam(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 508 508",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#84DBFF"
    },
    cx: 254,
    cy: 254,
    r: 254
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6E9EE"
    },
    d: "M216.4,353.6c0.8,0.4,1.6,0.4,2,0.8C218,354,217.2,354,216.4,353.6L216.4,353.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6E9EE"
    },
    d: "M279.6,313.6c-2,13.2-5.2,28.8-10.4,45.6c-4.8,0.8-9.6,1.2-14.8,1.2c-6.8,0-13.6-0.8-20-2 c1.6,0.4,3.2,0.4,5.2,0.8c-5.2-16.8-8.8-32.4-10.4-45.6c6-18.4,25.6-20,25.6-20S273.6,295.2,279.6,313.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6E9EE"
    },
    d: "M268.8,359.2L268.8,359.2c0.8,0,1.6-0.4,2.4-0.4C270.4,359.2,269.6,359.2,268.8,359.2z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F9B54C"
    },
    d: "M277.2,264.4c0,0,3.2,16.4-23.2,29.2l0,0c-26.4-12.8-23.2-29.2-23.2-29.2l0,0c0-0.4,0-0.4,0-0.8 c6.4,8,14.8,13.2,23.2,13.2c8.8,0,16.8-5.2,23.2-13.2C277.6,264,277.6,264,277.2,264.4C277.6,264.4,277.6,264.4,277.2,264.4z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F1543F"
    },
    d: "M254,293.6L254,293.6L254,293.6L254,293.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F1543F"
    },
    d: "M263.2,296.4l-3.2,8.8h-12.4l-3.2-8.8c5.6-2.4,9.6-2.8,9.6-2.8S258.4,294,263.2,296.4z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF7058"
    },
    d: "M268,359.6c-4.4,0.4-9.2,0.8-14,0.8c-4.8,0-9.2-0.4-14-0.8l7.6-54H260L268,359.6z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#324A5E"
    },
    d: "M337.2,320.4c-16.4,20.8-40.8,35.2-68.4,39.2c5.2-16.8,8.8-32.4,10.4-45.6l0,0 c0,0.4,6.8-24.4,3.2-40l46.8,22.4L337.2,320.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#324A5E"
    },
    d: "M239.2,359.2c-27.6-4-52-18.4-68.4-39.2l7.6-24l46.8-22c-3.6,15.6,3.2,40.4,3.2,40 C230.4,327.2,233.6,342.4,239.2,359.2z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#324A5E"
    },
    points: "225.2,274 225.2,274 216.4,278  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M277.6,264.4c0,0,3.2,16.8-23.6,29.6c0,0,19.6,1.6,25.6,20C279.6,314.4,290.4,274,277.6,264.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M230.4,264.4c0,0-3.2,16.8,23.6,29.6c0,0-19.6,1.6-25.6,20C228.4,314.4,217.6,274,230.4,264.4z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD05B"
    },
    d: "M284,245.6c-3.2,10-4.4,15.6-4.4,15.6c-6.8,9.2-15.6,15.6-25.2,15.6c-9.2,0-17.6-5.6-24-14l0,0 c-14.4-17.6-4.4-50.4-4.4-50.4c7.2,8,30.4,8.8,30.4,8.8c-9.6-1.6-11.6-8.8-11.6-9.6c2,4.8,24,8,24,8 C291.6,222.8,284,245.6,284,245.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#324A5E"
    },
    d: "M240.4,178.4c0,0,31.6-12.8,47.6,16c17.2,30.8-4.4,63.6-8.8,66.4c0,0,1.2-5.2,4.4-15.6 c0,0,7.6-22.8-15.6-26c0,0-22.4-3.2-24-8c0,0,1.6,8,11.6,10c0,0-23.2-0.4-30.4-8.8c0,0-10,32.4,4.4,50.4c0,0-24.8-20-22-50.8 C208,212,206.8,170,240.4,178.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M452.4,275.2v-42.4L400.8,218c-3.6-15.2-9.6-29.2-17.6-42l26-47.2l-30-30l-47.2,26 c-12.8-8-27.2-13.6-42-17.6l-14.8-51.6h-42.4L218,107.2c-15.2,3.6-29.2,9.6-42,17.6l-47.2-26l-30,30l26,47.2 c-8,12.8-13.6,27.2-17.6,42l-51.6,14.8v42.4l51.6,14.8c3.6,15.2,9.6,29.2,17.6,42l-26,47.2l30,30l47.2-26c12.8,8,27.2,13.6,42,17.6 l14.8,51.6h42.4l14.8-51.6c15.2-3.6,29.2-9.6,42-17.6l47.2,26l30-30l-26-47.2c8-12.8,13.6-27.2,17.6-42L452.4,275.2z M254,360.4 c-58.8,0-106.4-47.6-106.4-106.4S195.2,147.6,254,147.6S360.4,195.2,360.4,254S312.8,360.4,254,360.4z"
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeam);
export default __webpack_public_path__ + "static/media/team.0731c29ce853587f0694cc4abeac2a14.svg";
export { ForwardRef as ReactComponent };